import axios from '@/plugins/axios';
import ErrorHandle from '@/helpers/errors/errorHandle';

const initialState = {
  userId: null,
  changeBalanceDialogState: false,
  changeBalanceInfo: {},
};

const getters = {
  getUserId: (state) => state.userId,
  getChangeBalanceDialogState: (state) => state.changeBalanceDialogState,
  getChangeBalanceInfo: (state) => state.changeBalanceInfo,
};

const mutations = {
  setUserId(state, payload) {
    state.userId = payload;
  },
  setChangeBalanceDialogState(state, payload) {
    state.changeBalanceDialogState = payload;
  },
  setChangeBalanceInfo(state, payload) {
    state.changeBalanceInfo = payload;
  },
};

/* eslint-disable no-unused-vars */
const actions = {
  async changeBalance({ commit }, credentials) {
    try {
      const lang = localStorage.getItem('language') || '';
      const token = localStorage.getItem('token') || '';
      const { data } = await axios.post(
        `/transaction/${credentials.type}`,
        credentials.credentials,
        { headers: { Authorization: `Bearer ${token}`, Lang: lang } },
      );
      const { balance, message } = data.data;

      return { message, balance };
    } catch (error) {
      throw ErrorHandle(error, this);
    }
  },
  async updateTransaction(_, { id, credentials }) {
    try {
      const lang = localStorage.getItem('language') || '';
      const token = localStorage.getItem('token') || '';
      const { data } = await axios.put(`/transaction/${id}`, credentials, {
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
      });

      const { message } = data.data;

      return { message };
    } catch (error) {
      throw ErrorHandle(error, this);
    }
  },
  async changePassword({ commit }, passwordData) {
    try {
      const lang = localStorage.getItem('language') || '';
      const token = localStorage.getItem('token') || '';
      const {
        data,
      } = await axios.patch(
        `/${passwordData.type}/${passwordData.id}/password`,
        passwordData.data,
        { headers: { Authorization: `Bearer ${token}`, Lang: lang } },
      );

      return data;
    } catch (error) {
      throw ErrorHandle(error, this);
    }
  },
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  mutations,
  actions,
};
